var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tabs',{attrs:{"background-color":"#467FA5","color":"white"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }